<template>
  <div class="center-bottom-stats">
    <div class="stats-container">
      <div 
        class="stat-item" 
        v-for="(stat, index) in statsData" 
        :key="index"
      >
        <!-- 雷达扫描图标 -->
        <div class="radar-icon">
          <img src="~@/assets/large/radar1.gif" alt="" class="radar-img" />
        </div>
        <!-- 数值和标签 -->
        <div class="stat-content">
          <div class="stat-value">{{ formatValue(stat.value) }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CenterBottomStats',
  data() {
    return {
      statsData: [
        {
          label: '云诊所',
          value: 21529
        },
        {
          label: 'Pad诊所',
          value: 527
        },
        {
          label: '医生数',
          value: 19581
        },
        {
          label: '患者数',
          value: 16512120
        }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    formatValue(value) {
      // 添加千分位分隔符
      return value.toLocaleString('zh-CN')
    },
    loadData() {
      // 这里可以调用接口获取统计数据
      // this.$http.post(process.env.VUE_APP_API_HOST + "/center_bottom_stats", {
      //   "extra_params": {}
      // }).then((res) => {
      //   if (res.data && res.data.data) {
      //     this.statsData = res.data.data
      //   }
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.center-bottom-stats {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  color: #fff;

  .stats-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    gap: 15px;
    padding: 0 15px;

    .stat-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;

      .radar-icon {
        width: 53px;
        height: 53px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        flex-shrink: 0;

        .radar-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .stat-content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        flex: 1;

        .stat-value {
          font-size: 18px;
          font-weight: bold;
          color: #fff;
          line-height: 1.2;
          margin-bottom: 2px;
          letter-spacing: 0.5px;
          font-family: 'Arial', sans-serif;
        }

        .stat-label {
          font-size: 13px;
          color: #999;
          line-height: 1.2;
          font-weight: 400;
          letter-spacing: 0.5px;
          opacity: 0.7;
        }
      }
    }
  }
}

</style>

